// src/lib/api/admin.ts
// Note: client.ts uses `export default apiClient` (not a named export).
import apiClient from './client';
import type {
  MeData,
  OverviewData,
  TenantUsageRow,
  TimeseriesPoint,
  UsageFilters,
  UsersFilters,
  UserUsageRow,
  PaginatedResponse,
} from '@/types/admin';

const cleanParams = (obj: Record<string, unknown>): Record<string, string> => {
  const out: Record<string, string> = {};
  for (const [k, v] of Object.entries(obj)) {
    if (v === undefined || v === null || v === '') continue;
    out[k] = String(v);
  }
  return out;
};

export const fetchMe = async (): Promise<MeData> => {
  const { data } = await apiClient.get<{ data: MeData }>('/api/me');
  return data.data;
};

export const fetchUsageOverview = async (f: UsageFilters): Promise<OverviewData> => {
  const { data } = await apiClient.get<{ data: OverviewData }>('/admin/usage/overview', {
    params: cleanParams({ from: f.from, to: f.to, tenantId: f.tenantId }),
  });
  return data.data;
};

export const fetchUsageUsers = async (
  f: UsersFilters
): Promise<PaginatedResponse<UserUsageRow>> => {
  const { data } = await apiClient.get<PaginatedResponse<UserUsageRow>>('/admin/usage/users', {
    params: cleanParams({
      from: f.from,
      to: f.to,
      tenantId: f.tenantId,
      search: f.search,
      page: f.page,
      perPage: f.perPage,
      sortBy: f.sortBy,
      sortDir: f.sortDir,
    }),
  });
  return data;
};

export const fetchUsageTenants = async (f: {
  from: string;
  to: string;
}): Promise<TenantUsageRow[]> => {
  const { data } = await apiClient.get<{ data: TenantUsageRow[] }>('/admin/usage/tenants', {
    params: cleanParams(f),
  });
  return data.data;
};

export const fetchUsageTimeseries = async (f: UsageFilters): Promise<TimeseriesPoint[]> => {
  const { data } = await apiClient.get<{ data: TimeseriesPoint[] }>('/admin/usage/timeseries', {
    params: cleanParams({
      from: f.from,
      to: f.to,
      tenantId: f.tenantId,
      metric: 'prompts',
      granularity: 'day',
    }),
  });
  return data.data;
};
